import { traveler } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { TravelerDescription as TravelerDescriptionComponent } from '@eti/components';
import { jsx as _jsx } from "react/jsx-runtime";
const TravelerDescription = _ref => {
  let {
    className,
    name,
    shouldShowIcon,
    type
  } = _ref;
  const {
    t
  } = useTranslation();
  const description = traveler.resolveLabelFromType(type, t('Adult'), t('Child'), t('Infant'));
  return /*#__PURE__*/_jsx(TravelerDescriptionComponent, {
    className: className,
    description: description,
    name: name,
    shouldShowIcon: shouldShowIcon,
    type: type
  });
};
export default TravelerDescription;
//# sourceMappingURL=TravelerDescription.js.map